"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CropParameterWriter = void 0;
const free_cropParameter_1 = require("../cropParameter/free.cropParameter");
function writeFreeCropParameter(cropParameter) {
    const state = cropParameter.state;
    const x = state.x;
    const y = state.y;
    const width = state.width;
    const height = state.height;
    return {
        id: state.id,
        tag: 'free',
        x,
        y,
        width,
        height
    };
}
class CropParameterWriter {
    static write(cropParameter) {
        if (free_cropParameter_1.CollectionModelFreeCropParameter.isFree(cropParameter)) {
            return writeFreeCropParameter(cropParameter);
        }
        throw new Error(`Unexpected drawable: ${cropParameter.id}:${cropParameter.state.tag}`);
    }
}
exports.CropParameterWriter = CropParameterWriter;
//# sourceMappingURL=collection.model.write.cropParameter.js.map